<template>
  <div class="overview-page">
    <div class="stat-row" v-for="(row, rowIndex) in cardRows" :key="rowIndex">
      <div class="stat-card" v-for="item in row" :key="item.key">
        <div class="card-header">
          <div class="title-wrap">
            <span class="title">{{ item.title }}</span>
          </div>
          <span class="date-tag">{{ $t('investorList.jr') }}</span>
        </div>
        <div class="card-body" :class="{ amount: item.isAmount }">
          {{ formatValue(overviewData[item.key], item.isAmount) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInvestorTransactionOverview } from '@/webpublicapi/vietnamBackstage'
import { FenToDong } from '@/utils/filter'

export default {
  name: 'Overview',
  filters: {
    FenToDong
  },
  data() {
    return {
      overviewData: {
        rechargeNum: 0,
        rechargeAmount: 0,
        freezeNum: 0,
        freezeAmount: 0,
        frozenOutNum: 0,
        frozenOutAmount: 0,
        returnNum: 0,
        returnAmount: 0,
        withdrawNum: 0,
        withdrawAmount: 0,
      },
    }
  },
  computed: {
    cardRows() {
      return [
        [
          { title: this.$t('investorList.czbs'), key: 'rechargeNum', isAmount: false },
          { title: this.$t('investorList.czje'), key: 'rechargeAmount', isAmount: true },
        ],
        [
          { title: this.$t('investorList.rgbs'), key: 'freezeNum', isAmount: false },
          { title: this.$t('investorList.rgje'), key: 'freezeAmount', isAmount: true },
          { title: this.$t('investorList.fkbs'), key: 'frozenOutNum', isAmount: false },
          { title: this.$t('investorList.fkje'), key: 'frozenOutAmount', isAmount: true },
        ],
        [
          { title: this.$t('investorList.tzdqbd'), key: 'returnNum', isAmount: false },
          { title: this.$t('investorList.dqjdje'), key: 'returnAmount', isAmount: true },
        ],
        [{ title: this.$t('investorList.txje'), key: 'withdrawAmount', isAmount: true }],
      ]
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const res = await getInvestorTransactionOverview()
        const data = res && res.respData ? res.respData : {}
        this.overviewData = {
          rechargeNum: data.rechargeNum || 0,
          rechargeAmount: data.rechargeAmount || 0,
          freezeNum: data.freezeNum || 0,
          freezeAmount: data.freezeAmount || 0,
          frozenOutNum: data.frozenOutNum || 0,
          frozenOutAmount: data.frozenOutAmount || 0,
          returnNum: data.returnNum || 0,
          returnAmount: data.returnAmount || 0,
          withdrawNum: data.withdrawNum || 0,
          withdrawAmount: data.withdrawAmount || 0,
        }
      } catch (err) {
        console.log(err)
      }
    },
    formatValue(value, isAmount) {
      const num = Number(value || 0)
      if (isAmount) {
        return this.$options.filters.FenToDong(num)
      }
      return num
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.overview-page {
  padding: 8px;
}

.stat-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 38px;
}

.stat-card {
  width: 374px;
  height: 150px;
  border: 1px solid #52c41a;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.card-header {
  height: 40px;
  background: #0c9254;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  gap: 8px;
}

.title-wrap {
  display: inline-flex;
  align-items: center;
  font-size: 24px;
  line-height: 1;
  min-width: 0;
  flex: 1;
}

.title {
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.help-icon {
  font-size: 14px;
  margin-left: 3px;
}

.date-tag {
  min-width: 56px;
  height: 20px;
  background: #fff;
  color: #111;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}

.card-body {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  font-weight: 500;
  color: #111;
}

.card-body.amount {
  font-size: 38px;
  transform: scale(0.5);
  transform-origin: center center;
  letter-spacing: 0.2px;
}
</style>
